import axios from 'axios'

import { useAuthStore } from './store/auth'
import { pinia } from './store/pinia'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL
})

api.interceptors.request.use(
  config => {
    const authStore = useAuthStore(pinia)
    const bookingLocationId = authStore.locationId
    if (bookingLocationId) {
      config.headers['Location-ID'] = bookingLocationId
    }

    return config
  },

  error => {
    return Promise.reject(error)
  }
)

export default api
